export enum AuthProviders {
  OKTA = 'OKTA',
  AZURE = 'AZURE',
}
